import { render, staticRenderFns } from "./useremail.vue?vue&type=template&id=67058d5a&"
import script from "./useremail.vue?vue&type=script&lang=js&"
export * from "./useremail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports